import { Injectable, OnDestroy } from '@angular/core';
import { Product, loadOpt, Req, Commerce } from 'src/environments/environment';
import { UserService } from './user.service';
import { NavController, LoadingController, ModalController } from '@ionic/angular';
import { RestService } from './rest.service';
import { InAppBrowser } from '@ionic-native/in-app-browser/ngx';
import { Storage } from '@ionic/storage-angular';
import { Globals } from './globals';

export interface Cupon {
  discount: number;
  message: string;
  unit: string;
}

@Injectable({
  providedIn: 'root'
})
export class CartService{

  public total = 0;
  public cart: Product[] = [];
  public user_id = '';
  public delivery_price = 0;
  public discounts = 0;
  public delivery_min = 0;
  public delivery_price_min;
  public price_min;
  public delivery_suplement: number;
  public delivery_order_min;
  public amount;
  public address = '';
  public postal_code = '';
  public observations = '';
  public Commerce = {} as Commerce;
  public take_away:number = 0;
  public totalOrders:number = 0;
  public cupon: any = '';
  public client_time = '';
  public num_habitacion: string;
  public cp_hotel: string;
  public base_imponible: number;
  public price_final: number;
  public repartoGratis: string;

  actual_address = {
    address: '',
    door: '',
    number: '', 
    postal_code: '',
    lat: '',
    lng: '',
    id_address: 0, 
    primary:0, 
    state:0, 
    user_id:0
  };

  constructor(
    public user: UserService,
    private modal: ModalController,
    private nav: NavController,
    private iab: InAppBrowser,
    private rest: RestService,
    private stop: LoadingController,
    private storage: Storage,
    private global: Globals
    ) {
      this.storage.create();
    }

  async getActual(){
    await this.storage.get('actual_address').then(data => {
      if (data) {
        this.actual_address = data;
        
      }
    }).catch((error) => console.error(error))
  }

  /* async ionViewWillEnter(){
    await this.storage.get('actual_address').then(data => {
      if (data) {
        // console.log(data)
        this.actual_address = data;
        console.log(data)
        // this.user.adressesUser.unshift(this.actual_address);
        
        // this.user.adressesUser.pop()
      }
    })
    // console.log(this.user.adressesUser)
  } */

  async reCalculate(){

    const loading = await this.stop.create(loadOpt);
    await loading.present();

    const total = new Promise( (resolve) => {
      let totalTemp: number;
      totalTemp = 0;

      if ( this.cart.length > 0 ){
        this.cart.forEach(
            (product) => {
              totalTemp += parseFloat(product.price.toString());
              if ( product.extras !== null ){
                product.extras.forEach(
                  (extras) => {
                    if ( extras.added > 0){
                      totalTemp += (extras.added * parseFloat(extras.price_extra.toString()) );
                    }
                  }
                );
              }
            });
      }

      resolve(totalTemp);
    });

    total.then( (result: number) => {
      this.total = result;
      this.totalOrders = result;
      localStorage.setItem('TotalPrice',this.total.toString())
      this.calculateTotalOrder();
      loading.dismiss();
    });
  }

  async recalculateWithTotalOrder(){
    const loading = await this.stop.create(loadOpt);
    await loading.present();

    const total = new Promise( (resolve) => {
      let totalTemp: number;
      totalTemp = 0;

      if ( this.cart.length > 0 ){
        this.cart.forEach(
            (product) => {
              totalTemp += parseFloat(product.price.toString());
              if ( product.extras !== null ){
                product.extras.forEach(
                  (extras) => {
                    if ( extras.added > 0){
                      totalTemp += (extras.added * parseFloat(extras.price_extra.toString()) );
                    }
                  }
                );
              }
            });
      }

      resolve(totalTemp);
    });

    total.then( (result: number) => {
      this.total = parseFloat(result.toString());
      localStorage.setItem('TotalPrice',this.total.toString())
      this.totalOrders += this.delivery_price;
      loading.dismiss();
    });
  }

  calculateTotalOrder(){
    let id_address = 0;
    if ( this.user.adressesUser.length > 0){
      this.rest.getAdress()
      if (this.user.adressSelected == -1) {
        id_address = this.actual_address.id_address;
      }else{
        id_address = this.user.adressesUser[this.user.adressSelected].id_address;
      }
    }
  }

  checkPrice(){

    if ( this.take_away === 1 ){ return true; }
    if ( this.total >= this.delivery_min ){
      return true;
    } else {
      return false;
    }
  }

  checkNumberHotel(){
    if ( this.num_habitacion != ''){ return true; } else{return false}
  }

  CheckProfile() {

    if (this.user.data ){

      if (this.user.data.phone === null || this.user.data.phone.length === 0){ return false; }
      if (this.user.data.name === null || this.user.data.name.length === 0){ return false; }
      if (this.user.data.email === null || this.user.data.email.length === 0){ return false; }

    }

    return true;
  }

  async pushService(product){
    this.cart.push(JSON.parse(JSON.stringify(product)));
    localStorage.setItem('cart',JSON.stringify(this.cart))
    localStorage.setItem('commerce',JSON.stringify(this.Commerce))
    localStorage.setItem('role_id', JSON.stringify(this.Commerce.role_id))
    localStorage.setItem('address',this.Commerce.address)
    localStorage.setItem('cp_hotel',this.Commerce.postal_code)
    this.recalculateWithTotalOrder();
  }

  PayOrder(){
    let address = {
      id_address: 0, 
      address: '',
      door: '',
      number: '',
      postal_code: '',
      lat: '',
      lng: ''
    }
    this.getActual();
    if (this.take_away === 0){
      if ( this.user.adressesUser.length < 1 ){
        this.user.generateToast('No existen direcciones, añade una');
        return false;
      }
      if (localStorage.getItem('role_id') == '2') {
        address = this.getUserAddress();
      }

      if (localStorage.getItem('role_id') == '5') {
        address.address = localStorage.getItem('address') + ", nº habitación: " + this.num_habitacion;
        address.postal_code = localStorage.getItem('cp_hotel')
      }
    }
      console.log(this.user.data)
      this.rest.EnviarPedido(
        this.cart,
        this.total,
        this.totalOrders,
        this.user_id,
        address.id_address, 
        address.address,
        address.door,
        address.number,
        address.postal_code,
        this.observations, 
        this.take_away, 
        this.cupon.code, 
        this.client_time, 
        address.lat, 
        address.lng,
        this.user.data.id).subscribe(
      (data) => {
  
          this.iab.create(data['data']['payment_url']);
          this.user.generateToast(data['data']['message']);
          this.total = 0;
          this.address = '';
          this.postal_code = '';
          this.observations = '';
          this.discounts = 0;
          this.take_away = 0;
          this.totalOrders = 0;
          this.cupon = [];
          this.cart = [];
          this.client_time = '';
          this.num_habitacion = '';
          this.nav.navigateRoot('/tabs/tab1');
          localStorage.removeItem('cart')
          localStorage.removeItem('commerce')
          localStorage.removeItem('TotalPrice')
          localStorage.removeItem('cp_hotel')
  
        },
      (error) => {
        this.user.generateToast(error.error.data);
      });

  }

  getUserAddress(){
    let address = {
      id_address: 0,
      address: '',
      number: '',
      door: '',
      postal_code: '',
      lat: '',
      lng: ''
    }
    if (this.user.adressSelected == -1) {
      address.id_address = 0;
      address.address = this.global.address_map;
      address.number = this.global.number_map;
      address.door = this.global.puerta_map;
      address.postal_code = this.global.cp_map;
      address.lat = this.global.lat;
      address.lng = this.global.lng;

    }else{
      
      address.id_address = this.user.adressesUser[this.user.adressSelected].id_address;
      address.address = this.user.adressesUser[this.user.adressSelected].address;
      address.number = this.user.adressesUser[this.user.adressSelected].number;
      address.door = this.user.adressesUser[this.user.adressSelected].door;
      address.postal_code = this.user.adressesUser[this.user.adressSelected].postal_code;
      address.lat = this.user.adressesUser[this.user.adressSelected].lat;
      address.lng = this.user.adressesUser[this.user.adressSelected].lng;

    }

    return address;

  }
}
